//====================================================
//  Count thumbnail item
//====================================================
var countThumbnailItem = 0;
var thumbnailLimit = 0;
function fn_parts_count_thumbnail_item() {
	if ($(".js-gallery-btn").length) {
		countThumbnailItem = $('.js-gallery-thumbnail figure').length;

		if ($window.width() > bp_medium){
			thumbnailLimit = 6;
		}

		if ($window.width() < bp_medium && $window.width() > bp_small){
			thumbnailLimit = 4;
		}

		if ($window.width() < bp_small && $window.width() > bp_xsmall){
			thumbnailLimit = 3;
		}

		if ($window.width() < bp_xsmall){
			thumbnailLimit = 2;
		}

		if (countThumbnailItem > thumbnailLimit){
			$(".js-gallery-btn").addClass(class_active);
		} else {
			$(".js-gallery-btn").removeClass(class_active);
		}
	}
}
